export function getInitialPassengerState(passengers, initialValue = false) {
    const initialState = {};
    passengers.forEach(passenger => {
        initialState[passenger.id] = initialValue;
    });
    return initialState;
}
